import PageContext from "global_state/context/PageContext"
import { useEffect, useState } from "react"
import { useContext } from "react"
import { BiHide, BiShow } from "react-icons/bi"

import { createUserPassword } from "services/user_services/CreateUserPasswordS"
import { PageType } from "types/PageI"
import Title from "components/Title"

import FormSCSS from 'assets/scss/Form.module.scss'
import SCSS from 'assets/scss/CreatePassword.module.scss'
import AppSCSS from 'assets/scss/App.module.scss'

import content from 'languages/CreatePassword.json'
import UserContext from "global_state/context/UserContext"

function CreatePassword() {
    const {user} = useContext(UserContext)
    const {page, dispatchPage} = useContext(PageContext)
    const [new_user_password, setNewUserPassword] = useState<string>("")
    const [password_visibility, setPasswordVisibility] = useState(false)
    const [create_password_response, createPasswordResponse] = useState<any>()

    let language = page.settings.language

    const isPasswordStrongEnought = (password: string): boolean => {
        if (password.length < 8) {
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: "weak_password"
                    }
                }
            }) 
            return false
        }
        return true
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        // console.log(event);
        // console.log(user.client_id);
        // console.log(new_user_password);
        
        if (!isPasswordStrongEnought(new_user_password)) {
            return 
        }
        createPasswordResponse (await createUserPassword(user.client_id, user.email, language, new_user_password))
    }

    useEffect(() => {
        // console.log(create_password_response);
        if (create_password_response === 'password_set') {
            dispatchPage({type: "render", payload: {page: PageType.log_in_form}})
        }
    }, [create_password_response])

    useEffect(() => {
        // console.log(new_user_password);
        
    }, [new_user_password])

    return (
        <div className={[FormSCSS.form_wrapper, SCSS.create_password].join(" ")}>
            <Title back_arrow={true} title={content[language].title} page={PageType.create_online_account}></Title>
            <form 
                className={FormSCSS.form}
                onSubmit={(event) => {handleSubmit(event)}}>
                
                <div className={SCSS.info_text}>{content[language].text}</div>
                
                <label className={FormSCSS.label} htmlFor="password">
                    <input className={FormSCSS.input}
                        type={(password_visibility) ? "text" : "password"} 
                        name="password" 
                        id="password" 
                        placeholder={content[language].input_user_password_placeholder} 
                        // value={new_user_password}
                        onChange={(e) => {setNewUserPassword(e.target.value)}}/>
                    <div 
                        onClick={() => setPasswordVisibility(!password_visibility)} 
                        className={FormSCSS.password_visibility}>
                        {(password_visibility) ? 
                            <BiShow/> : <BiHide/>}
                    </div>
                </label>

                <button type="submit"
                    className={[AppSCSS.button, AppSCSS.red].join(" ")}>
                    {content[language].button_submit}
                </button>
            </form>
        </div>
    )
}

export default CreatePassword